<template>
  <div class="py-5">
    <div class="d-flex flex-column align-center pb-5">
      <v-card-title class="chiffre-xxl secondary--text">
        Abonnement
      </v-card-title>
      <v-card-title class="intro texte-gris-fonce">
        Débloquez de nouvelles fonctionnalités pour mieux vous accompagner
      </v-card-title>
    </div>
    <div class="d-flex flex-row flex-wrap mt-6 justify-center">
      <div
        v-for="(offre, index) in offresAbonnement"
        :key="index"
        :class="$vuetify.breakpoint.xs ? '' : 'mx-5'"
        class="pb-5"
      >
        <OffreAbonnement :offre="offre" />
      </div>
    </div>
    <div
      v-if="!isAbonneCulturial"
      class="d-flex flex-row flex-wrap mt-6 justify-center"
    >
      <AideAbonnement />
    </div>
    <div class="d-flex flex-row flex-wrap my-6 justify-center">
      <TemoignagesAbonnement />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import OffreAbonnement from '@/views/offre-abonnement/components/offre-abonnement.vue'
import AideAbonnement from '@/views/offre-abonnement/components/aide-abonnement.vue'
import TemoignagesAbonnement from '@/views/offre-abonnement/components/temoignages-abonnement.vue'

export default {
  name: 'OffresAbonnement',
  components: {TemoignagesAbonnement, AideAbonnement, OffreAbonnement},
  data () {
    return {
      loading: false,
      erreur: false
    }
  },
  computed: {
    ...mapGetters({
      offresAbonnement: 'offreAbonnement/offresAbonnement',
      abonnements: 'adherent/abonnements'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    }
  },

  created () {
    this.loadOffresAbonnement()
  },

  methods: {
    ...mapActions({
      getAllOffreAbonnementAdherent: 'offreAbonnement/getAllOffreAbonnementAdherent'
    }),

    loadOffresAbonnement () {
      this.loading = true
      this.erreur = false

      this.getAllOffreAbonnementAdherent()
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    }
  }
}
</script>
